function flip(s: string): string {
  return [...s].reverse().join('')
}

/**
 * Puts the contact email together. The page serves it reversed and in two halves, so it is never in
 * the markup whole (see src/templates/email.ts); this turns each such link into a working `mailto:`.
 */
export function revealEmails(root: ParentNode = document) {
  for (const link of root.querySelectorAll<HTMLAnchorElement>('a.email[data-user][data-host]')) {
    const address = `${flip(link.dataset.user!)}@${flip(link.dataset.host!)}`
    link.href = `mailto:${address}`
    link.textContent = address
  }
}
